import R from "ramda";
import { planCategoryMap } from "@/utils/commonDef";

export const getConfig = (pick, i18n = R.identity) => {
  let base = R.pick(pick, {
    product_type_name: {
      // label: i18n("产品类型"),
      suffix: "like",
      type: "input",
    },
    code: {
      // label: i18n("计划编号"),
      suffix: 'like',
      type: 'input'
    },
    plan_code: {
      // label: i18n("计划编号"),
      suffix: 'like',
      type: 'input'
    },
    name: {
      // label: i18n("产品名称"),
      suffix: 'like',
      type: 'input'
    },
    standard_model: {
      // label: i18n("规格型号"),
      suffix: 'like',
      type: 'input'
    },
    material_code: {
      // label: i18n("物料编号"),
      suffix: 'like',
      type: 'input'
    },
    product_code: {
      // label: i18n("产品编号"),
      suffix: 'like',
      type: 'input'
    },
    product_name: {
      // label: i18n("产品名称"),
      suffix: 'like',
      type: 'input'
    },
    producer_code: {
      // label: i18n("员工编号"),
      suffix: 'like',
      type: 'input'
    },
    producer_name: {
      // label: i18n("员工名称"),
      suffix: 'like',
      type: 'input'
    },
    process_code: {
      // label: i18n("工序编码"),
      suffix: 'like',
      type: 'input'
    },
    process_name: {
      // label: i18n("工序名称"),
      suffix: 'like',
      type: 'input'
    },
    category: {
      // label: i18n("计划"),
      suffix: 'equal',
      type: 'radio',
      options: [
        {
          label: i18n(planCategoryMap[1]),
          value: 1
        },
        {
          label: i18n(planCategoryMap[2]),
          value: 2
        }
      ]
    },
    types: {
      // label: i18n("所选类型"),
      suffix: 'eq',
      type: 'radio',
      options: [
        {
          label: i18n('提前'),
          value: -1
        },
        {
          label: i18n('延后'),
          value: 1
        }
      ]
    },
    order_code: {
      // label: i18n("订单编码"),
      suffix: 'like',
      type: 'input'
    },
    plan_start_time: {
      // label: i18n("计划预计开始时间"),
      suffix: 'dategt',
      type: 'datePicker',
      style: {
        width: '100%'
      },
      props: {
        valueFormat: 'YYYY-MM-DD'
      }
    },
    plan_end_time: {
      // label: i18n("计划预计结束时间"),
      suffix: 'datele',
      type: 'datePicker',
      style: {
        width: '100%'
      },
      props: {
        valueFormat: 'YYYY-MM-DD'
      }
    },
    start_time: {
      // label: i18n("计划实际开始时间"),
      suffix: 'dategt',
      type: 'datePicker',
      style: {
        width: '100%'
      },
      props: {
        valueFormat: 'YYYY-MM-DD'
      }
    },
    forecast_end_time: {
      // label: i18n("计划实际结束时间"),
      suffix: 'datele',
      type: 'datePicker',
      style: {
        width: '100%'
      },
      props: {
        valueFormat: 'YYYY-MM-DD'
      }
    },
    overdue_duration: {
      // label: i18n("实际超期时长左边界"),
      suffix: 'ge',
      type: 'duration'
    },
    end_time: {
      // label: i18n("理论结束的开始日期"),
      suffix: 'datele',
      type: 'datePicker',
      style: {
        width: '100%'
      },
      props: {
        valueFormat: 'YYYY-MM-DD'
      }
    },
    employee_name: {
      // label: i18n("开工人员"),
      suffix: 'like',
      type: 'input'
    },
    process_status: {
      suffix: 'eq',
      type: 'radio',
      options: [
        {
          label: i18n('page_plan_status_2'),
          value: 1
        },
        {
          label: i18n('page_plan_status_3'),
          value: 2
        },
        {
          label: i18n('page_plan_status_6'),
          value: 5
        }
      ]
    }
  })
  let extra = {}
  pick.map(p => {
    if (p.indexOf('extend') > -1) {
      extra[p] = {
        // label: i18n("扩展字段"),
        suffix: "like",
        type: "input",
      }
    }
  })
  return Object.assign({}, base, extra)
}

export const PRODUCT = ["code", "name", "standard_model", "material_code"];

export const PRODUCTION_PLAN = [
  "code",
  "product_code",
  "product_name",
  "standard_model",
  "category",
  "order_code",
  "plan_start_time",
  "plan_end_time",
  "product_type_name",
  "extend",
];

export const PROCESS_SCHEDULE = [
  "product_code",
  "product_name",
  "standard_model",
  "category",
  "order_code",
  "plan_start_time",
  "plan_end_time",
  "code",
  "product_type_name",
];

export const PLAN_SCHEDULE = [
  "product_code",
  "product_name",
  "standard_model",
  "category",
  "order_code",
  "plan_start_time",
  "plan_end_time",
  "start_time",
  "forecast_end_time",
  "code",
  "product_type_name",
];

export const PLAN_OVERDUE = [
  "product_code",
  "product_name",
  "standard_model",
  "category",
  "order_code",
  "plan_start_time",
  "plan_end_time",
  "start_time",
  "overdue_duration",
  "types",
  "forecast_end_time",
  "end_time",
  "code",
  "product_type_name",
];

export const PLAN_WIP = [
  "product_code",
  "product_name",
  "standard_model",
  "category",
  "order_code",
  "plan_start_time",
  "plan_end_time",
  "code",
  "product_type_name",
];

export const PLAN_EMPLOYEE_PERFORMANCE = [
  "product_code",
  "product_name",
  "standard_model",
  "producer_code",
  "producer_name",
  "process_code",
  "process_name",
  "start_time",
  "end_time",
  "plan_code",
  "product_type_name",
];

export const PRODUCTION_CALENDAR = [
  "process_code",
  "process_name",
  "process_status",
  "product_code",
  "product_name",
  "employee_name",
]
